import React from 'react'

function ImportablePatientHistory() {
  return (
    <div>ImportablePatientHistory</div>
  )
}

export default ImportablePatientHistory